import {
    GTM_ATTRIBUTE_PRODUCT_LIST_OBSERVER,
} from '../helpers/gtm/gtmSelectors';

const triggerGtmProductsObserver = (rootElement) => {
    document.body.setAttribute(GTM_ATTRIBUTE_PRODUCT_LIST_OBSERVER, rootElement);
};

window.sga.triggerGtmProductsObserver = triggerGtmProductsObserver;
console.log('productObserver initialized')